import React, {useState} from 'react';
import {browserHistory} from 'react-router';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

import TabPanel from 'components/coaching/widgets/TabPanel';
import {GridNote} from '@components/grid/GridNote';

import {KpiBulbIcon} from '@components/icon/KpiBulbIcon';

import KpiGoalsList from './kpi-list';
import {ChainLinkButton} from './kpi-list/ChainLinkButton';
import cursorPng from './cursor.png';

import './KpiGoals.styl';
import {getNumberQueryParam} from 'utils/getQueryParam';
import AssignmentListContainer from './assignment-list/AssignmentListContainer';
import {KpiOrderBy} from '@store/@types/kpi';

export enum TABS {
  LIST = 'Performance Goals & KPIs',
  ASSIGNMENT = 'Goal Assignment',
}

export const KpiAdminPage: React.FC<any> = () => {
  const [orderBy, setOrderBy] = useState<KpiOrderBy>('name');
  const [direction, setDirection] = useState<'asc' | 'desc'>('asc');
  const onChange = newOrderBy => {
    if (newOrderBy === orderBy) {
      setDirection(direction === 'asc' ? 'desc' : 'asc');
    } else {
      setOrderBy(newOrderBy);
      setDirection('asc');
    }
  };

  const initialTab = getNumberQueryParam(location, 'tabIndex') ?? 0;
  const handleChangeTab = i => browserHistory.replace(`/admin/kpis?tabIndex=${i}`);
  return (
    <div className="kpi-goals">
      <div className="kpi-content">
        <h1>Performance Goals & KPIs</h1>
        <Button
          className="kpi-add-button"
          variant="contained"
          color="primary"
          onClick={() => browserHistory.push('/admin/kpis/create')}>
          Add KPI
        </Button>
        <TabPanel
          tabs={Object.values(TABS)}
          onChange={handleChangeTab}
          defaultSelectedIdx={initialTab}
          panels={[
            <KpiGoalsList orderBy={orderBy} direction={direction} setOrderBy={onChange} />,
            <AssignmentListContainer
              orderBy={orderBy}
              direction={direction}
              setOrderBy={onChange}
            />,
          ]}
        />
      </div>
      <GridNote title="SET UP GOALS" className="sidebar">
        <div className="sidebar-content">
          <h2>Create KPIs.</h2>
          <h2>Merge KPIs into Goals.</h2>

          <ol>
            <li>Add any number of KPIs</li>
            <li>Select 2 or more KPIs:</li>
            <div className="kpi-example">
              <div>
                <Checkbox color="primary" className="checkbox" checked={true} /> <KpiBulbIcon />{' '}
                Make 200 dials per week
              </div>
              <div>
                <Checkbox color="primary" className="checkbox" checked={true} /> <KpiBulbIcon />{' '}
                Send 50 emails per week
              </div>
            </div>
            <li>Hit the link button to merge KPIs and create Goals:</li>
          </ol>
          <div className="link-example-img">
            <ChainLinkButton />
            <img src={cursorPng} alt="lint example pointer" />
          </div>
        </div>
      </GridNote>
    </div>
  );
};
